<template>
  <div :style="{ height: height }" class="sellCenter">
    <div class="inputWrap">
      <div class="header" ref="header">
        <div class="StoreWallateRechargeTitle">
          <el-page-header @back="goBack" content=""> </el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'customeManage' }"
              ><span class="titleText">客户管理</span></el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ name: 'customeSetting' }"
              ><span class="titleText">编辑客户角色</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>

        <div>
          <el-button type="info" size="mini" @click="onSubmit">
            提交修改
          </el-button>
        </div>
      </div>

      <div
        :style="{ height: formHeight + 'px', backgroundColor: '#fff' }"
        class="formBox"
      >
        <el-form ref="form" :model="form" size="mini" label-width="80px">
          <div class="formInfo">
            <el-alert
              v-show="showErr.show"
              :title="showErr.text"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <div class="formInnerBox" :style="{ height: formHeight - 40 + 'px' }">
            <el-form-item label="客户名称: ">
              <div class="userName">
                <!-- {{ currentEditRow.name }} -->
                <el-input
                  class="itemClass"
                  v-model="form.clientName"
                  placeholder=""
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="客户电话: ">
              <el-input
                class="itemClass"
                v-model="form.clientPhone"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="预付款余额: ">
              <div class="common green">{{ form.balance }} 元</div>
            </el-form-item>
            <el-form-item label="客户地址: ">
              <el-input
                class="itemClass"
                v-model="form.clientAdress"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人名称: ">
              <el-input
                class="itemClass"
                v-model="form.name"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人电话: ">
              <el-input
                class="itemClass"
                v-model="form.telphone"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="录入时间: ">
              <div class="common">
                {{ form.addDate }}
              </div>
            </el-form-item>
            <el-form-item label="上次联系时间: ">
              <div class="common">{{ form.lastDate }}</div>
            </el-form-item>
            <el-form-item label="责任人: ">
              <el-input
                class="itemClass"
                v-model="form.salesName"
                placeholder=""
              ></el-input>
            </el-form-item>
            <el-form-item label="货到付款: ">
              <!-- <el-input v-model="form.name" placeholder=""></el-input> -->
              <el-checkbox v-model="form.pay_flag"
                ><div :class="['common', form.pay_flag ? 'green' : null]">
                  {{ form.pay_flag ? "支持" : "不支持" }}
                </div></el-checkbox
              >
            </el-form-item>
            <el-form-item v-if="form.pay_flag" label="账期天数: ">
              <el-input
                class="itemClass"
                type="number"
                v-model="form.payment_days"
                placeholder=""
              >
                <template slot="append">天</template>
              </el-input>
              <div class="common">账期天数为整数，0默认为无账期服务</div>
            </el-form-item>
            <!-- <el-form-item label="说明: ">
                  <el-input  class='itemClass' v-model="form.name" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="备忘: ">
                  <el-input  class='itemClass' v-model="form.name" placeholder=""></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="员工角色: ">
              <el-checkbox-group v-model="form.checkList">
                <el-checkbox
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import {
  addGoodsUrl,
  updateGoodsUrl,
  roleSetting,
  setEmpRoleUrl,
  listRoleUnderMeUrl,
  updateClientUrl
} from "@/api/api";

export default {
  props: ["height"],
  data() {
    return {
      form: {
        
      },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
      roleList: [],
    };
  },
  created() {},

  mounted() {
    this.setFormHeight();
    window.addEventListener("resize", this.setFormHeight);
    console.log("currentEditRow", this.currentEditRow);
    this.form = {
      ...this.currentEditRow,
      pay_flag:this.currentEditRow.pay_flag?true:false
      };
  },
  computed: {
    ...mapState(["userInfo", "companyInfo", "currentEditRow"]),
  },
  methods: {
    getRole() {
      return new Promise((resolve, reject) => {
        let { access_token } = this.userInfo;
        // return
        let url = listRoleUnderMeUrl;
        let data = {
          access_token,
          store_id: 0,
        };
        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url,
        })
          .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
              const { data } = res.data;
              console.log(data);
              this.roleList = data.filter((item) => {
                return item.name != "管理员";
              });
              resolve();
            } else {
              this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
            }
          })
          .catch((err) => {
            if (err) {
              this.$alert(JSON.stringify(err));
            } else {
              this.$alert("请求异常");
            }
          });
      });
    },

    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      }, 100);
    },
    formateRole() {
      let { checkList } = this.form;
      if (checkList.length) {
        let arr = [];
        checkList.forEach((item) => {
          for (var k in roleSetting) {
            if (roleSetting[k] == item) {
              arr.push(k);
            }
          }
        });

        return arr.join(",");
      } else {
        return "4";
      }
    },
    getRId() {
      let { checkList } = this.form;
      if (checkList.length) {
        let arr = [];
        this.roleList.filter((item) => {
          let _some = checkList.some((m) => m == item.name);
          if (_some) {
            arr.push(item.id);
          }
        });
        return arr.join(",");
      } else {
        return "4";
      }
    },
    onSubmit() {
      console.log(this.form);
      let { payment_days,pay_flag } = this.form;

      if (pay_flag&&(payment_days<0||(parseInt(payment_days)!=payment_days))) {
        this.showErr = {
          show: true,
          text: "账期天数应为正值整数",
        };
        return;
      }

      this.showErr = {
        show: false,
        text: "",
      };

      let { access_token } = this.userInfo;

      // return
      let url = updateClientUrl;

      let data = {
        access_token,
        toUserId: this.currentEditRow.userId,
        storeId: this.currentEditRow.storeId,
        ...this.form,
        empUserId: this.form.empUserId,
        pay_flag:this.form.pay_flag?1:0,

      };
      let param = new URLSearchParams();
      for (var k in data) {
        if((!data[k])&&(k!='pay_flag')){

        }else{
            param.append(k, data[k]);
        }
        
      }

      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.$router.go(-1);
            this.$message({
              message: "编辑成功",
              type: "success",
            });
          } else {
            this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
          }
        })
        .catch((err) => {
          if (err) {
            this.$alert(JSON.stringify(err));
          } else {
            this.$alert("请求异常");
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 20px;
  padding: 20px;
}
.forItem {
  width: 266px;
}
.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 500px;
  height: 30px;
  margin-bottom: 20px;
}
.userName {
  color: #666;
  font-size: 13px;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.itemClass {
  width: 200px;
}
.common {
  font-size: 12px;
  color: #666;
}
.green {
  color: green;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/CustomeSetting.vue